import React from "react";

import { animated } from "@react-spring/web";

import { getDataTestId } from "src/utils";
import { useLoader } from "./hooks";

import styles from "./style.module.scss";

import Title from "src/assets/images/background-title.svg";

export const Loader = () => {
  const { values } = useLoader();
  return values.loader(
    (style, open) =>
      open && (
        <animated.div
          className={styles.loader}
          {...getDataTestId("loader")}
          style={style}
        >
          <div className={styles.sprite} />
          <img src={Title} />
        </animated.div>
      )
  );
};
